export async function postNewClientNotificationSubscription({
  email,
  firmUuid,
  backendUrl,
  frontStrapiToken,
}: {
  email: string
  firmUuid: string
  backendUrl: string
  frontStrapiToken: string
}) {
  const response = await fetch(
    `${backendUrl}/api/accounting-notification-subscription`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${frontStrapiToken}`,
      },
      body: JSON.stringify({
        email,
        firmUuid,
      }),
    },
  )

  const responseData = await response.json()
  return responseData
}
